export enum ArrowVariantEnum {
    THICK = 'thick',
    NORMAL = 'normal',
    THIN = 'thin',
}
